import { AxiosInstance } from "axios"
import { OutlookSession } from "./outlookCreateOrderTypes"

export enum OutlookPageQuery {
    OUTLOOK_SESSION_FOR_USER = "outlook-session-for-user",
}

type OutlookSessionForUserParam = Readonly<{
    userId: number
    sessionUid: string
}>

export type OutlookSessionForUserResponse = Readonly<{
    session: OutlookSession
}>

export async function fetchOutlookSessionForUser(
    { userId, sessionUid }: OutlookSessionForUserParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<OutlookSessionForUserResponse> {
    const url = `/users/${userId}/sessions/${sessionUid}`
    const { data } = await axios.get(url, {
        signal,
        params: {},
    })

    return data
}
